import {
  SEARCH,
  STORE_ID,
  SORT,
  ACTIVE,
} from './fields';

export default function payload() {
  return {
    name_molicar_fipe: {
      field: SEARCH,
    },
    store_ids: [{
      field: STORE_ID,
    }],
    sort: {
      field: SORT,
    },
    active: {
      field: ACTIVE,
    },
  };
}
